import {
  REVIEW_STATUS,
  IN_WARRANTY_STATUS,
  OUT_OF_WARRANTY_STATUS,
} from 'utils/constants';
import { isNumber } from './price';

export const getWarrantyStatus = ({ status } = {}) => {
  if (status === REVIEW_STATUS) {
    return 'Calix Review';
  } else if (status === IN_WARRANTY_STATUS) {
    return 'True';
  } else {
    return 'False';
  }
};

export const isOutOfWarrantyWithoutRepairFee = (warrantyResult = {}) => {
  return (
    warrantyResult.status === OUT_OF_WARRANTY_STATUS &&
    !isNumber(warrantyResult.product.outOfWarrantyPrice)
  );
};
